var _defs, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPowerDetect = function SvgPowerDetect(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgPowerDetect",
    width: 27.146,
    height: 18.29,
    viewBox: "0 0 27.146 18.29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .svgPowerDetect{fill:#2bbc8f}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "power-detect",
    className: "svgPowerDetect svgBase svgHover svgSelect",
    transform: "translate(0 -167.029)",
    d: "M26.017 178.558h-2.74l-2.07-5.633a1.128 1.128 0 0 0-2.121 0l-2.886 7.957-4.767-13.115a1.137 1.137 0 0 0-2.129 0l-3.928 10.79H1.137a1.132 1.132 0 0 0-.008 2.265h5.09a1.128 1.128 0 0 0 1.06-.746l3.13-8.61 4.776 13.115a1.137 1.137 0 0 0 2.129 0l2.893-7.957 1.255 3.453a1.128 1.128 0 0 0 1.069.746h3.529a1.133 1.133 0 0 0-.042-2.265z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPowerDetect, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/power-detect.97af1a65.svg";
export { ForwardRef as ReactComponent };